import Service from "../Service";

const resource = "hmnPreviousContract/";

export default {
  pagination(dtr, requestID) {
    return Service.post(resource + "pagination", dtr, {
      params: { requestID },
    });
  },
  save(parameters, requestID) {
    return Service.post(resource + "saveMassive", parameters, {
      params: { requestID },
    });
  },
  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID },
    });
  },
};
